import styled from 'styled-components'

export const InfoPanel = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
`
InfoPanel.displayName = 'InfoPanel'

export const InfoPanelGrey = styled(InfoPanel)`
  background-color: ${({ theme }) => theme.palette.nswPaletteOffWhite};
`
InfoPanelGrey.displayName = 'InfoPanelGrey'

export const InfoPanelGreyGap = styled(InfoPanelGrey)`
  margin-top: 2rem;
  gap: 1.5rem;
`

InfoPanelGreyGap.displayName = 'InfoPanelGreyGap'

export const PaymentRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
`

PaymentRow.displayName = 'PaymentRow'

export const PaymentHeading = styled.span`
  font-size: 24px;
  font-weight: 600;
`

PaymentHeading.displayName = 'PaymentHeading'

export const PaymentDataCell = styled.span`
  text-align: right;
`

PaymentDataCell.displayName = 'PaymentDataCell'
